const css = `._7N6Lva__iconWrapper{transition:transform .3s}._7N6Lva__iconWrapper._7N6Lva__expanded{transform:rotate(90deg)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"iconWrapper":"_7N6Lva__iconWrapper","expanded":"_7N6Lva__expanded"};
